import { createReducer } from 'store/createReducer';
import { PpiPageModel } from 'models/PpiPageModel';
import initialPageState from 'components/Pagelayout/initialPageState';
import { AgreementCheckAction, PPI_AGREEMENT_CHECK } from 'views/PPI/actions';

export default createReducer<PpiPageModel>(
  {
    ...initialPageState,
    agreements: []
  },
  {
    [PPI_AGREEMENT_CHECK]: (state, action: AgreementCheckAction) => ({
      ...state,
      agreements: state.agreements.map(a =>
        a.id !== action.id
          ? a
          : {
              ...a,
              checked: !action.checked
            }
      )
    })
  }
);
